// Collection Page layout Changer

document.addEventListener("DOMContentLoaded", function () {
  const fourBoxBtn = document.querySelector(".four-box-layout");
  const singleLineBtn = document.querySelector(".single-line-layout");
  const gridContainer = document.getElementById("main-collection-product-grid");
  const layoutChanger = document.querySelector(".product_grid_layout_changer");

  // Add default classes
  if (gridContainer) {
    gridContainer.classList.add("four-layout-product-grid");
  }
  if (layoutChanger) {
    layoutChanger.classList.add("four-layout-product-grid");
  }

  if (fourBoxBtn && singleLineBtn && gridContainer && layoutChanger) {
    fourBoxBtn.addEventListener("click", function () {
      gridContainer.classList.remove("singleLine-layout-product-grid");
      layoutChanger.classList.remove("singleLine-layout-product-grid");

      gridContainer.classList.add("four-layout-product-grid");
      layoutChanger.classList.add("four-layout-product-grid");
    });

    singleLineBtn.addEventListener("click", function () {
      gridContainer.classList.remove("four-layout-product-grid");
      layoutChanger.classList.remove("four-layout-product-grid");

      gridContainer.classList.add("singleLine-layout-product-grid");
      layoutChanger.classList.add("singleLine-layout-product-grid");
    });
  }
  
});

// Image resolution Fix

document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".pixellated_images img");

  images.forEach((img) => {
    img.removeAttribute("srcset");
  });
});

// Shopify Forms App

document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".shopify_form_container");
  if (!formContainer) return;

  const observer = new MutationObserver(() => {
    const form = document.querySelector("form-embed");
    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;
      if (shadow) {
        const sheet = new CSSStyleSheet();
        sheet.insertRule(`
          section._formContainer_1q1d2_30 {
            max-width: 100% !important;
          }
        `);
        sheet.insertRule(`
          h2._textHeading_2aowh_35 {
            font-size:28px;
            font-family: 'St Marie';
            font-weight: 400;
            color: #076e43;
          }
        `);
        sheet.insertRule(`
          form._formFieldset_cit2d_82 {
              input,label,textarea,p._label_1wdej_10 {
              font-size:17px;
              font-family: 'St Marie';
              color:#333333;
            }
          }
        `);
        sheet.insertRule(`
          ._selectToggle_1wdej_25{
            font-family: 'St Marie';
          }
        `);
        sheet.insertRule(`
        @media (width >= 1200px){
          ._formPhoneInputContainer_1ym3p_6 {
            grid-template-columns: minmax(0, 0.2fr) minmax(0, 2.2fr);
          }
        } 
        `);
        sheet.insertRule(`
          form._formFieldset_8skcf_76 {
            ._selectToggle_1yit2_25,input{
              max-height:51px;
            }
          }
        `);
        sheet.insertRule(`
          button._formSubmitButton_cit2d_96 {
              color: rgb(255, 255, 255);
              font-size: 19px;
              font-family: "St Marie";
              width: 140px !important;
              border-radius: 30px;
              margin-top: 30px;
          }
        `);
        sheet.insertRule(`
          button._selectToggle_1wdej_25 span {
              font-size: 17px;
          }
        `);
        sheet.insertRule(`
        @media (width <= 490px){
            ._container_3eyaa_70 {
            display: block;
          }
        } 
        `);
        shadow.adoptedStyleSheets.push(sheet);
      }
      formContainer.classList.add("loaded");
    }
  });

  // Start observing outside the callback
  observer.observe(document.body, { childList: true, subtree: true });
});

// Shopify Apps Dropdown Placeholder text

document.addEventListener("DOMContentLoaded", () => {
  const formContainer = document.querySelector(".shopify_form_container");
  if (!formContainer) return;
  const isArabic = document.documentElement.lang === "ar";

  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector("form-embed");
    if (formEmbed) {
      observer.disconnect();

      const shadow = formEmbed.shadowRoot;
      if (!shadow) return;

      const shadowObserver = new MutationObserver(() => {
        // Find all matching containers with label <p>Type of Booking</p>
        const containers = shadow.querySelectorAll("._selectContainer_1wdej_6");

        containers.forEach((container) => {
          const label = container.querySelector("._label_1wdej_10");
          if (
            label &&
            label.textContent.trim() ===
              (isArabic ? "نوع الحجز" : "Type of Booking")
          ) {
            const span = container.querySelector("._selectToggleText_1wdej_25");
            const button = container.querySelector("._selectToggle_1wdej_25");

            if (span && button) {
              // Set initial text
              span.textContent = isArabic ? "اختر نوع الحجز" : "Select Booking";

              // Apply RTL styling if Arabic
              if (isArabic) {
                span.style.textAlign = "right";
                span.style.direction = "rtl";
                span.style.display = "block"; // ensure proper layout
              }

              // Remove text on click
              button.addEventListener("click", () => {
  span.textContent = "";
}, { once: true });
            }
          }
        });

        shadowObserver.disconnect();
      });

      shadowObserver.observe(shadow, { childList: true, subtree: true });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function updatePlaceholder() {
  const input = document.querySelector(
    ".mobile-search .site-search-handle input"
  );
  if (input) {
    input.placeholder =
      window.innerWidth < 768
        ? "Search"
        : "Search for pairings, ingredients, or inspiration...";
  }
}

window.addEventListener("resize", updatePlaceholder);
window.addEventListener("DOMContentLoaded", updatePlaceholder);

// Arabic Form Translation

document.addEventListener("DOMContentLoaded", () => {
  const isArabic = document.documentElement.lang === "ar";
  if (!isArabic) return;

  const formContainer = document.querySelector(".shopify_form_container");
  if (!formContainer) return;

  const translations = {
    "If you have any questions or inquiries regarding our events and classes, please feel free to contact us.": "إذا كانت لديك أي أسئلة أو استفسارات بخصوص فعالياتنا ودوراتنا، فلا تتردد في التواصل معنا.",
    Name: "الاسم",
    Email: "البريد الإلكتروني",
    "Phone Number": "رقم الهاتف",
    "Type of Booking": "نوع الحجز",
    "Blue Cheese": "جبن أزرق",
    "Soft Cheese": "جبن طري",
    "Hard Cheese": "جبن قاسي",
    "Preferred Date & Time": "التاريخ والوقت المفضلان",
    "Additional Details or Questions": "تفاصيل إضافية أو استفسارات",
    Submit: "إرسال",
    Success: "تم بنجاح",
    "Thank you. The form has been submitted.": "شكرًا لك. تم إرسال النموذج.",
  };

  const replaceText = (root) => {
    const elements = root.querySelectorAll("*");
    elements.forEach((el) => {
      if (
        el.childNodes.length === 1 &&
        el.childNodes[0].nodeType === Node.TEXT_NODE
      ) {
        const originalText = el.textContent.trim();
        if (translations[originalText]) {
          el.textContent = translations[originalText];
          el.style.textAlign = "right";
          el.style.direction = "rtl";

          if (el.tagName.toLowerCase() === "label") {
            el.style.right = "15px";
            el.style.left = "unset";
          }
        }
      }
    });
  };

  const applyFloatingLabelEffect = (root) => {
    const inputs = root.querySelectorAll("input, textarea, select");

    inputs.forEach((input) => {
      input.style.textAlign = "right";

      const wrapper =
        input.closest("div, .form-group, .field-wrapper, .form-field") ||
        input.parentElement;
      if (!wrapper) return;

      const label = wrapper.querySelector("label");
      if (!label) return;

      const applyStyle = () => {
        label.style.fontSize = "85%";
        label.style.transform = "translateY(-10px)";
      };

      const resetStyle = () => {
        if (!input.value.trim()) {
          label.style.fontSize = "";
          label.style.transform = "";
        }
      };

      input.addEventListener("focus", applyStyle);
      input.addEventListener("blur", resetStyle);

      if (input.value.trim()) applyStyle();
    });
  };

  const observeDynamicHeading = (shadow) => {
    const headingObserver = new MutationObserver(() => {
      const heading = shadow.querySelector("h2._formBannerHeading_z5ku3_9");
      if (heading) {
        heading.style.display = "flex";
        heading.style.justifyContent = "flex-start";
      }
    });

    headingObserver.observe(shadow, {
      childList: true,
      subtree: true,
    });
  };

  const enhanceShadowContent = (shadow) => {
    replaceText(shadow);
    applyFloatingLabelEffect(shadow);
    observeDynamicHeading(shadow);
  };

  const watchFormEmbed = () => {
    const embed = document.querySelector("form-embed");
    if (embed && embed.shadowRoot) {
      const shadow = embed.shadowRoot;
      enhanceShadowContent(shadow);

      const shadowObserver = new MutationObserver(() => {
        enhanceShadowContent(shadow);
      });

      shadowObserver.observe(shadow, { childList: true, subtree: true });
    } else {
      setTimeout(watchFormEmbed, 100); // retry if not ready
    }
  };

  const checkAndReplace = () => {
    replaceText(formContainer);
    applyFloatingLabelEffect(formContainer);
    watchFormEmbed();
  };

  checkAndReplace();

  const observer = new MutationObserver(() => {
    checkAndReplace();
  });

  observer.observe(formContainer, { childList: true, subtree: true });

  formContainer.addEventListener("click", (e) => {
    const toggleBtn = e.target.closest("._selectToggle_1yit2_25");
    if (toggleBtn) {
      setTimeout(() => {
        checkAndReplace();
      }, 100);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const CATEGORY_PARAM = 'filter.p.m.custom.category';
  const CATEGORY_MAP = {
    'Soft Cheese': ['Soft', 'طري/لينة'],
    'جبن ناعم': ['Soft', 'طري/لينة'],
    'Hard Cheese': ['Hard', 'قاسية'],
    'جبن صلب': ['Hard', 'قاسية'],
    'Blue Cheese': ['Blue', 'زرقاء'],
    'جبنة زرقاء': ['Blue', 'زرقاء']
  };

  const normalize = (text) => text.replace(/\(\d+\)\s*$/, '').trim().toLowerCase();

  // Filter values can be metaobject IDs rather than plain text, so match on the value or the visible label
  const findCategoryCheckbox = (form, values) => {
    const wanted = values.map(normalize);
    const checkboxes = Array.from(form.querySelectorAll('input[type="checkbox"]'));
    const categoryCheckboxes = checkboxes.filter((input) => input.name === CATEGORY_PARAM || /category/i.test(input.name));
    const pools = [categoryCheckboxes, checkboxes];

    for (const pool of pools) {
      const match = pool.find((input) => {
        const label = form.querySelector(`label[for="${input.id}"]`);
        return wanted.includes(normalize(input.value)) || (label && wanted.includes(normalize(label.textContent)));
      });
      if (match) return match;
    }
    return null;
  };

  const scrollToProductGrid = () => {
    const grid = document.getElementById('main-collection-product-grid');
    if (!grid) return;
    const target = grid.closest('.shopify-section') || grid;
    const stickyHeader = document.querySelector('.sticky-header');
    const offset = (stickyHeader ? stickyHeader.offsetHeight : 0) + 20;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  };

  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('.custom-filter-click a');
    if (!link) return;

    const values = CATEGORY_MAP[link.textContent.trim()];
    if (!values) return;
    e.preventDefault();

    const form = document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile');
    const checkbox = form && findCategoryCheckbox(form, values);

    if (checkbox) {
      const params = new URLSearchParams(new FormData(form));
      params.delete(checkbox.name);
      params.append(checkbox.name, checkbox.value);

      if (typeof FacetFiltersForm !== 'undefined') {
        FacetFiltersForm.renderPage(params.toString());
      } else {
        window.location.search = params.toString();
        return;
      }
    } else {
      console.warn('Cheese filter: no category checkbox found for', values);
    }

    scrollToProductGrid();
  });
});

  document.addEventListener("DOMContentLoaded", function () {
    const langButtons = document.querySelectorAll('#lang-list-ancmt button[type="submit"]');

    langButtons.forEach(button => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        const selectedLocale = button.value; // "en", "ar", etc.
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split("/").filter(Boolean); // remove empty parts

        const supportedLocales = ["en", "ar"]; // Add more if needed
        let newPath;

        if (supportedLocales.includes(pathParts[0])) {
          // If current path starts with a locale
          if (selectedLocale === "en") {
            // Remove locale prefix for English (default)
            pathParts.shift();
            newPath = "/" + pathParts.join("/");
          } else {
            // Replace existing locale
            pathParts[0] = selectedLocale;
            newPath = "/" + pathParts.join("/");
          }
        } else {
          // No existing locale in path
          newPath = selectedLocale === "en"
            ? currentPath
            : "/" + selectedLocale + currentPath;
        }

        // Redirect to cleaned path (without query string)
        window.location.href = newPath;
      });
    });
  });